/**
 * Clones an error object.
 *
 * Previously we used `structuredClone` to clone the error, but it
 * does not preserve all properties of the error.
 */
export function cloneError(error: Error) {
  const errorClone = new Error(error.message);

  // enumerate all other properties of the error
  for (const [key, value] of Object.entries(error)) {
    (errorClone as any)[key] = value;
  }

  // not enumerable properties are not copied by default, so we need to set them manually
  errorClone.name = error.name;
  errorClone.constructor = error.constructor;
  errorClone.stack = error.stack;
  errorClone.cause = error.cause;

  return errorClone;
}
